import { useCallback } from "react";

import { useDispatch } from "react-redux";

import { columnsSelectionTrackingService } from "app/pages/sales-intelligence/common-components/column-picker/columnsSelectionTrackingService";
import { setDataCostVisibility } from "app/pages/sales-intelligence/modules/quota/store/action-creators";
import { setIsColumnPickerOpen } from "app/pages/sales-intelligence/sub-modules/common/store/action-creators";

type HookValue = {
    openWithDataCost: (quota: number, dataCost: number) => void;
};

/**
 * Hook for controlling the column picker modal
 *
 * IMPORTANT: `openWithDataCost` only sets Redux state. The actual rendering of
 * data cost UI elements depends on the consuming component using
 * `useLeadsColumnSelectionPlugins` (or equivalent) to create the plugin
 * configuration that reads `isDataCostVisible` state.
 *
 * @see useLeadsColumnSelectionPlugins - creates plugins that render based on isDataCostVisible
 */
export const useColumnPickerControls = (): HookValue => {
    const dispatch = useDispatch();

    const openWithDataCost = useCallback((quota: number, dataCost: number) => {
        columnsSelectionTrackingService.columnPickerLink.trackClicked(quota, dataCost);

        dispatch(setDataCostVisibility(true));
        dispatch(setIsColumnPickerOpen(true));
    }, []);

    return { openWithDataCost };
};
